<!-- ToastContent.vue -->
<template>
    <div>
        <strong class="toast-title">{{ title }}</strong>
        <p class="toast-description">{{ description }}</p>
    </div>
</template>

<script lang="ts">
export default {
    props: {
        title: String,
        description: String,
    },
};
</script>
